import Items from './Items'

const initialState = {
  error : false,
  projectId : null,
  perPage : 100,
  total : 0,
  items : []
}

module.exports = Items.reducer( initialState, 'PROJECT_ACCOUNT', 'projectId', [ 'projectId' ] )
